export const getYouTubeVideoId = (url = "") => {
    const trimmed = url.trim();
    if (!trimmed)
        return null;

    const patterns = [
        /youtu\.be\/([^?&/]+)/,
        /youtube\.com\/embed\/([^?&/]+)/,
        /youtube\.com\/shorts\/([^?&/]+)/,
        /[?&]v=([^?&/]+)/,
    ];

    for (const pattern of patterns) {
        const match = trimmed.match(pattern);
        if (match?.[1])
            return match[1];
    }

    return null;
};

export const getYouTubeEmbedUrl = (url = "") => {
    const videoId = getYouTubeVideoId(url);
    return videoId ? `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&mute=1&rel=0` : "";
};
